import { useLocation } from 'react-router-dom';
import { useProjectsSearch } from '@/contexts/ProjectsSearchContext';
import { NavbarSearchPopoverControl } from '@/components/Layout/NavbarSearchPopoverControl';

export function ProjectsSearchNavbarControl() {
  const location = useLocation();
  const isProjectsRoute = location.pathname === '/' || location.pathname === '/projects';
  const { searchInput, setSearchInput, clearSearch } = useProjectsSearch();

  if (!isProjectsRoute) return null;

  return (
    <NavbarSearchPopoverControl
      value={searchInput}
      onChange={setSearchInput}
      onClear={clearSearch}
      placeholder="Поиск по проектам…"
      ariaLabel="Поиск по всем проектам"
      dialogTitle="Поиск по проектам"
    />
  );
}
